import React, { ReactNode, useEffect, useState } from 'react';
import { IActionProps, Toolbar } from '../../ui/Toolbar';
import { IApplicationModule } from '../../ui/IApplicationModule';
import { LocationDetail } from 'shared/models/api/models';
import { DetailFormWrapper } from '../../ui/DetailForm';
import { ViewOrEditButtonText } from './general-administration-data';
import { IModalBoxProps } from 'components/ui/ModalBox';
import { IConfirmProps } from 'components/ui/ConfirmationBox';
import { getLocationsWithDetail, getLocationWithDetail, updateLocationMobile } from 'shared/services/locationApi';
import { DataGrid } from 'components/ui/DataGrid';

interface ISiteMobileListProps {
    module: IApplicationModule,
    // loadingState: string,
    // setLoadingState: (newState: string) => void,
    setConfirmProps: (confirmProps: IConfirmProps | null) => void,
    setModalProps: (modalProps: IModalBoxProps | null) => void
}


export const SiteMobileNumbers = (props: ISiteMobileListProps) => {

    const [locations, setLocations] = useState([] as LocationDetail[]);
    const [selectedLocations, setSelectedLocations] = useState([] as LocationDetail[]);


    const getLocationList = async () => {
        await getLocationsWithDetail()
            .then(result => {
                if (result) {
                    setLocations(result);
                }
            });
    };

    const actionClicked = (action: IActionProps) => {
        if (checkMinMax(action)) {
            switch (action.name) {

                case ViewOrEditButtonText:
                    return viewOrEdit(selectedLocations[0]);

                default:
                    console.warn("Unhandled action: " + action.name);
            }
        }
    };

    const checkMinMax = (action: IActionProps) => {
        if (selectedLocations.length === 0 && (action.minSelectedCount ?? 0) > 0) {
            msgBox("Please select one item to continue.");
            return false;
        }

        if (!!action.maxSelectedCount) {
            if (selectedLocations.length > action.maxSelectedCount) {
                if (action.maxSelectedCount === 1) {
                    msgBox("Please select only one item to continue.");
                } else {
                    msgBox("Please select " + action.maxSelectedCount + " or fewer items to continue.");
                }

                return false;
            }
        }

        return true;
    };
    const saveLocationDetail = async (locationDetail: LocationDetail): Promise<LocationDetail> => {
        var result = await updateLocationMobile(locationDetail);
        console.log()
        if (!result) {
            throw new Error("Call to save mobile number failed");
        }
        return locationDetail;
    }


    const onDataChanged = (location: LocationDetail, msg: string | undefined) => {
        console.log('on changed');
        const idx = locations.findIndex(l => l.id === location.id);

        if (idx > -1) {
            // take a copy of the array
            var arr = locations.map(u => u);

            // replace the row with the updated location
            arr[idx] = location;

            // set the new array back to the all locations
            setLocations(arr);
        } else {
            // just get all users again
            getLocationList();
        }

        props.setModalProps(null);
        msgBox(msg ?? "Your request has been successfully completed.");
    };

    const onGridRowDoubleClick = (row: LocationDetail) => {
        viewOrEdit(row);
    };

    const viewOrEdit = (row: LocationDetail) => {
        if (row) {
            props.setModalProps({
                className: "allowed-domain-modal",
                body:
                    <DetailFormWrapper<LocationDetail>
                        load={() => getLocationWithDetail(row.id)}
                        save={saveLocationDetail}
                        viewName="edit"
                        onDataChanged={onDataChanged}
                        module={props.module}
                        setConfirmationProps={props.setConfirmProps}
                        closeDialog={() => props.setModalProps(null)}
                    />
            });
        }
    };

    const msgBox = (msg: ReactNode) => {
        if (props.setConfirmProps) {
            props.setConfirmProps({
                message: msg,
                options: ["OK"],
                defaultOption: "OK",
                setResult: result => {
                    if (props.setConfirmProps) {
                        props.setConfirmProps(null);
                    }
                }
            });
        }
    };


    var loading = false;

    useEffect(() => {
        if (!loading) {
            loading = true;

            getLocationList();
        }
    }, []);

    const compareInts = (a: number, b: number) => {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    };


    return (
        <div>
            <Toolbar
                actions={props.module?.actions ?? []}
                onClick={actionClicked}
                selectedCount={selectedLocations.length} />

            <DataGrid
                rows={locations}
                selectedItems={selectedLocations}
                setSelectedItems={setSelectedLocations}
                selectMode={props.module.selectMode}
                pageSize={props.module.pageSize ?? 10}
                columns={
                    (props.module.columns ?? [])
                        .filter(c => c.showInGrid)
                        .sort((a, b,) => compareInts(a.showInGrid ?? 0, b.showInGrid ?? 0))
                    ?? []
                }
                onDoubleClick={onGridRowDoubleClick} />
        </div>
    );

}


export default SiteMobileNumbers;